<ng-container [ngSwitch]="level()">
  <h1 *ngSwitchCase="1" [ngClass]="baseClass()"><ng-content></ng-content></h1>
  <h2 *ngSwitchCase="2" [ngClass]="baseClass()"><ng-content></ng-content></h2>
  <h3 *ngSwitchCase="3" [ngClass]="baseClass()"><ng-content></ng-content></h3>
  <h4 *ngSwitchCase="4" [ngClass]="baseClass()"><ng-content></ng-content></h4>
  <h5 *ngSwitchCase="5" [ngClass]="baseClass()"><ng-content></ng-content></h5>
  <h6 *ngSwitchCase="6" [ngClass]="baseClass()"><ng-content></ng-content></h6>
</ng-container>
